import { apiRequest } from '@/shared/api/client';
import {
  retryAllResultSchema,
  stuckDeliveriesSchema,
  type RetryAllResult,
  type StuckDeliveries,
} from '@/entities/stuck-deliveries/types';

const PATH = '/v1/admin/stuck-deliveries';

/* Операции, застрявшие в очереди доставки: посмотреть и отправить заново.
 *
 * Повтор не создаёт новую операцию — он возвращает в очередь ту же самую строку, со всеми её
 * отметками о том, что уже успело пройти. Поэтому дважды списать он не может, а вот дозавершить
 * наполовину выполненную — обязан. */
export const stuckDeliveriesApi = {
  list: async (params: { event_type?: string; limit?: number } = {}): Promise<StuckDeliveries> => {
    const search = new URLSearchParams();
    if (params.event_type !== undefined) search.set('event_type', params.event_type);
    if (params.limit !== undefined) search.set('limit', String(params.limit));
    const query = search.toString();
    return stuckDeliveriesSchema.parse(
      await apiRequest<unknown>(query === '' ? PATH : `${PATH}?${query}`, { method: 'GET' }),
    );
  },

  retry: async (id: string): Promise<void> => {
    await apiRequest<void>(`${PATH}/${id}/retry`, { method: 'POST', json: {} });
  },

  retryAll: async (eventType?: string): Promise<RetryAllResult> =>
    retryAllResultSchema.parse(
      await apiRequest<unknown>(`${PATH}/retry`, {
        method: 'POST',
        json: eventType === undefined ? {} : { event_type: eventType },
      }),
    ),
};
